import React from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { RestrictedToScopedView } from "components/auth";
import DataGrid, { DataGridItem } from "components/data-grid";
import { NotAllowedPage } from "components/page";
import { useCurrentCustomerContext } from "../../components/current-customer-context";
import CurrentCustomerSelector from "../../components/current-customer-context/current-customer-selector";

const CustomerChangePage = () => {
  const { customers } = useCurrentCustomerContext();

  if (!customers?.length) {
    return <NotAllowedPage />;
  }

  return (
    <RestrictedToScopedView fallback={<NotAllowedPage />}>
      <Dashboard>
        <PageHeaderBar title="app.page.customer.change" />
        <PageSection>
          <DataGrid>
            <DataGridItem big>
              <CurrentCustomerSelector customers={customers ?? []} />
            </DataGridItem>
          </DataGrid>
        </PageSection>
      </Dashboard>
    </RestrictedToScopedView>
  );
};

export default CustomerChangePage;
